import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { warnAndNotify } from '../../../Honeybadger';
import { ProgramDetailResource, ProgramSegment } from '../../../ProgramStore/Types';
import ProgramSequenceProgress from './ProgramSequenceProgress';
import PercentComplete from './PercentComplete';

interface Props {
  programDetailResource: ProgramDetailResource;
  currentSegment: Maybe<ProgramSegment>;
}

const ProgressBar: React.FC<Props> = ({ programDetailResource }) => {
  switch (programDetailResource.payload.kind) {
    case 'active': {
      const activeProgram = programDetailResource.payload;
      return activeProgram.productDetails
        .map((pd) => {
          switch (pd.payload.kind) {
            case 'coaching':
              warnAndNotify(
                'Configuration Error',
                'Progress bar rendered for a coaching program',
                'Program detail progress',
              );
              return emptyFragment();
            case 'group-coaching':
            case 'program':
              return <PercentComplete programDetail={activeProgram} />;
            case 'program-sequence':
              return <ProgramSequenceProgress programDetail={activeProgram} />;
          }
        })
        .getOrElse(() => emptyFragment());
    }
    case 'completed':
    case 'expired':
    case 'upcoming':
    case 'inactive':
      return emptyFragment();
  }
};

export default observer(ProgressBar);
